import {
  AbstractJsonLexer1em5xl1wqsdtw as AbstractJsonLexer,
  charToTokenClass1wja4xge82waq as charToTokenClass,
  tokenDescription3r6eqmtoxe76u as tokenDescription,
} from './AbstractJsonLexer.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  toString1n9qg6fb0b5i8 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf1xbs558u7wr52 as indexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringJsonLexerWithComments3bzrli3gl2cah as StringJsonLexerWithComments } from './CommentLexers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonLexerClass;
function StringJsonLexer() {
  if (StringJsonLexerClass === VOID) {
    class $ extends AbstractJsonLexer() {
      constructor(source, configuration) {
        super(configuration);
        this.y2z_1 = source;
      }
      k2w() {
        return this.y2z_1;
      }
      e2z(position) {
        return position < this.k2w().length ? position : -1;
      }
      t2v() {
        var source = this.k2w();
        var cpos = this.n2o_1;
        $l$loop: while (!(cpos === -1) && cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.n2o_1 = cpos;
          return charToTokenClass(c);
        }
        this.n2o_1 = source.length;
        return 10;
      }
      p2v() {
        var current = this.n2o_1;
        if (current === -1)
          return false;
        var source = this.k2w();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
            continue $l$loop;
          }
          this.n2o_1 = current;
          return this.h2z(c);
        }
        this.n2o_1 = current;
        return false;
      }
      g2z() {
        var current = this.n2o_1;
        if (current === -1)
          return current;
        var source = this.k2w();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
          } else {
            break $l$loop;
          }
        }
        this.n2o_1 = current;
        return current;
      }
      b2w(expected) {
        if (this.n2o_1 === -1) {
          this.i2z(expected);
        }
        var source = this.k2w();
        var cpos = this.n2o_1;
        $l$loop: while (cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.n2o_1 = cpos;
          if (c === expected)
            return Unit_instance;
          this.i2z(expected);
        }
        this.n2o_1 = -1;
        this.i2z(expected);
      }
      h2w() {
        this.b2w(_Char___init__impl__6a9atx(34));
        var current = this.n2o_1;
        var closingQuote = indexOf(this.k2w(), _Char___init__impl__6a9atx(34), current);
        if (closingQuote === -1) {
          this.r2v();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected = tokenDescription(1);
          var position = false && this.n2o_1 > 0 ? this.n2o_1 - 1 | 0 : this.n2o_1;
          var s = this.n2o_1 === charSequenceLength(this.k2w()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.k2w(), position));
          var tmp$ret$1 = 'Expected ' + expected + ", but had '" + s + "' instead";
          this.f2u(tmp$ret$1, position);
        }
        var inductionVariable = current;
        if (inductionVariable < closingQuote)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (charCodeAt(this.k2w(), i) === _Char___init__impl__6a9atx(92)) {
              return this.consumeString2(this.k2w(), this.n2o_1, i);
            }
          }
           while (inductionVariable < closingQuote);
        this.n2o_1 = closingQuote + 1 | 0;
        return substring(this.k2w(), current, closingQuote);
      }
      j2w(keyToMatch, isLenient) {
        var positionSnapshot = this.n2o_1;
        try {
          if (!(this.t2v() === 6))
            return null;
          var firstKey = this.e2w(isLenient);
          if (!(firstKey === keyToMatch))
            return null;
          this.j2z();
          if (!(this.t2v() === 5))
            return null;
          return this.e2w(isLenient);
        }finally {
          this.n2o_1 = positionSnapshot;
          this.j2z();
        }
      }
    }
    initMetadataForClass($, 'StringJsonLexer');
    StringJsonLexerClass = $;
  }
  return StringJsonLexerClass;
}
function StringJsonLexer_0(json, source) {
  return !json.z2n_1.c2q_1 ? new (StringJsonLexer())(source, json.z2n_1) : new (StringJsonLexerWithComments())(source, json.z2n_1);
}
//region block: exports
export {
  StringJsonLexer_0 as StringJsonLexer3eu6xom7mrcfu,
  StringJsonLexer as StringJsonLexervr9dj3kex5li,
};
//endregion

//# sourceMappingURL=StringJsonLexer.mjs.map
